var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCrownLinear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-864 -342) translate(864 342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-864 -342) translate(864 342)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M18.425 15.867H3.575c-.151 0-.275.127-.275.283v.825c0 .156.124.283.275.283h14.85c.151 0 .275-.127.275-.283v-.825c0-.156-.124-.283-.275-.283zm1.65-11.334c-1.062 0-1.925.89-1.925 1.984 0 .269.052.524.148.758l-1.935 1.197c-.18.11-.372.163-.564.163-.382 0-.753-.206-.956-.57l-2.557-4.612c.388-.365.639-.885.639-1.47C12.925.89 12.062 0 11 0S9.075.889 9.075 1.983c0 .585.25 1.105.64 1.467L7.156 8.06c-.203.37-.574.571-.956.571-.192 0-.388-.053-.563-.163L3.702 7.271c.093-.234.148-.489.148-.758 0-1.094-.863-1.983-1.925-1.983S0 5.422 0 6.517C0 7.61.863 8.5 1.925 8.5c.069 0 .134-.014.2-.021L4.4 14.733h13.2l2.276-6.254c.065.007.13.021.199.021C21.137 8.5 22 7.611 22 6.517c0-1.095-.863-1.984-1.925-1.984zm-3.335 8.762H5.326L3.238 8.309l1.836 1.133c.344.213.732.322 1.13.322.788 0 1.52-.439 1.912-1.144l2.599-4.685c.096.014.189.028.288.028.1 0 .193-.014.29-.028l2.595 4.689c.391.705 1.124 1.14 1.91 1.14.4 0 .788-.113 1.132-.322l1.835-1.133-2.025 4.986z",
    transform: "translate(1 4)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrownLinear);
export default __webpack_public_path__ + "static/media/iconCrownLinear.60180b29.svg";
export { ForwardRef as ReactComponent };